import log from 'salvo-lite/log'
import axios from 'axios'
import Queue from '../helpers/Queue'

const ENDPOINTS = {
    'ADD': '/cart/add.js',
    'CART': '/cart.js',
    'CHANGE': '/cart/change.js',
    'PRODUCT': '/products/[REPLACE]/images.js',
    'PRODUCT_IMAGES': '/products/[REPLACE]/images.js',
    'UPDATE': '/cart/update.js'
}

class Bundle {
    constructor (theme, elem) {
        this._theme = theme
        this.queue = new Queue()
        this._elem = elem
        this._elems = Object.assign({
            bundleProducts: document.querySelectorAll('[data-bundle-selected-product]'),
            quantity: document.querySelector('#productQuantity')
        })
        this._data = Object.assign({
            event: 'click',
            bundleTitle: document.querySelector('[data-bundle-title]').getAttribute('data-bundle-title')
        }, JSON.parse(this._elem.getAttribute('data-bundle') || '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const {event, bundleTitle} = this._data
        this._elem.addEventListener(event, (e) => {
            e.preventDefault()
            // eslint-disable-next-line new-parens
            let rand = Number(new Date) % 1000000
            let props = { _bundle_id: rand, bundleTitle }
            let callback = null
            this._elems.bundleProducts.forEach((bundleProduct, key, arr) => {
                // if (Object.is(arr.length - 1, key)) {
                //     callback = this.goToCart
                // }
                this.addItem(bundleProduct.value, this._elems.quantity.value, props, callback)
            })
        })
    }

    // goToCart () {
    //     window.location = '/cart'
    // }

    addItem (variantId, quantity, props, callback) {
        const countItems = this._countItems
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/add.js'), {
                id: variantId,
                quantity: parseInt(quantity),
                properties: props || {}
            }).then((response) => {
                if (callback && typeof callback === 'function') {
                    callback(response.data)
                }
                countItems()
                return response.data
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    getCartEndpoint (type) {
        return `${type}?v=${(Math.floor(Math.random() * 10000000))}`
    }

    _countItems () {
        // axios.get(`${ENDPOINTS.CART}?cache=${Math.floor(100000000 + Math.random() * 900000000)}`).then((cart) => {
        axios.get(`${ENDPOINTS.CART}`).then((cart) => {
            if (cart.status === 200) {
                document.body.classList.add('cartItemAdded')
                if (document.querySelector('.cart-product-count') === null) {
                    var node = document.createElement('span')
                    var textnode = document.createTextNode('0')
                    node.classList.add('cart-product-count')
                    node.appendChild(textnode)
                    document.querySelector('.header__icon--cart').appendChild(node)
                }
                let count = cart.data.item_count
                cart.data.items.forEach(item => {
                    if (item.handle === 'pnm' || item.handle === 'carb-killa-pick-n-mix') {
                        count -= 1
                    }
                })
                document.querySelector('.cart-product-count').innerText = count

                var timer = setTimeout(function () {
                    document.body.classList.remove('cartItemAdded')
                    clearInterval(timer)
                }, 3000)

                if (!document.querySelector('body').classList.contains('cartItemAddedListening')) {
                    document.getElementById('product__added').addEventListener('mouseenter', function () {
                        if (document.querySelector('body').classList.contains('cartItemAdded')) {
                            clearTimeout(timer)
                        }
                    })
                    document.getElementById('product__added').addEventListener('mouseleave', function () {
                        if (document.querySelector('body').classList.contains('cartItemAdded')) {
                            timer = setTimeout(function () {
                                document.body.classList.remove('cartItemAdded')
                                clearInterval(timer)
                            }, 3000)
                        }
                    })
                }
                document.body.classList.add('cartItemAddedListening')
            }
        }).then(() => {
            //
        }).catch(error => console.error(error))
    }
}

export default Bundle



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Bundle.js